<template>
  <div class="body">
    <div class="detay">
      <div class="sayfabaslik">
        <div class="text">
          <div class="el-button-group">

            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/vezne/tahsilat" type="default">Tahsilat
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/vezne/odeme" type="default">Ödeme
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/vezne/abonelik" type="default">Abonelik Ödeme
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/vezne/banka" type="default">Banka Hesapları
            </router-link>


          </div>
        </div>

      </div>

      <router-view></router-view>
    </div>
  </div>
</template>
<script>
  import ManuelSanalPos from "../../components/Pack/Vezne/ManuelSanalPos";
  export default {
    components: {ManuelSanalPos},
    data() {
      return {
        PosHesabi: false
      }
    },
    created() {
      if (this.$store.getters.Yetki.vezne == '0') this.$router.push("/403");
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Vezne/_route.vue